import { render, staticRenderFns } from "./InputFormKana.vue?vue&type=template&id=01f063f4&"
import script from "./InputFormKana.vue?vue&type=script&lang=ts&"
export * from "./InputFormKana.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports